import React from "react";
import PropTypes from "prop-types";
import withSocialLogin from "../../../../../hocs/withSocialLogin";
import GoogleLogo from "../assets/google-logo.svg";

const SocialLogin = ({ initSocialLogin, translate }) => (
  <button
    onClick={() => initSocialLogin("GOOGLE")}
    type={"button"}
    className={
      "flex flex-row gap-2.5 rounded-full bg-white border-gray border-1 border-solid text-sm line-height-100 font-medium align-center p-3 w-full justify-center"
    }
  >
    <img src={GoogleLogo} alt={"Google Logo"} width={18} height={18} />
    <span>{translate("Log in using Google")}</span>
  </button>
);

SocialLogin.propTypes = {
  initSocialLogin: PropTypes.func
};

export default withSocialLogin(SocialLogin);
